import { TransferHttpCacheModule } from '@nguniversal/common';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FacultyComponent } from './faculty.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [FacultyComponent],
  imports: [
    TransferHttpCacheModule,
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: FacultyComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                './b-business-administration/b-business-administration.module'
              ).then((m) => m.BBusinessAAdministrationModule),
          },
        ],
      },
    ]),
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class FacultyModule { }
